import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export default function NotFound() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname.startsWith('/news/')) {
            navigate('/news');
        } else {
            navigate('/');
        }
    }, [navigate, location]);

    return null;
}
